import gql from "graphql-tag"

const GET_SOCIALS_PROSPECT_DEFAULTS = gql`
  query getSocialsProspectDefaults($accountId: ID!) {
    getSocialsProspectDefaults(accountId: $accountId) {
      defaultKeywords
    }
  }
`

export default GET_SOCIALS_PROSPECT_DEFAULTS
